/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SourcingSearchFilterOnIndustryExpertise
 */
export interface SourcingSearchFilterOnIndustryExpertise {
    /**
     * 
     * @type {Array<string>}
     * @memberof SourcingSearchFilterOnIndustryExpertise
     */
    humanIds: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof SourcingSearchFilterOnIndustryExpertise
     */
    ratingTwoOrMoreRequired?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SourcingSearchFilterOnIndustryExpertise
     */
    aggregation?: SourcingSearchFilterOnIndustryExpertiseAggregationEnum;
}


/**
 * @export
 */
export const SourcingSearchFilterOnIndustryExpertiseAggregationEnum = {
    And: 'AND',
    Or: 'OR'
} as const;
export type SourcingSearchFilterOnIndustryExpertiseAggregationEnum = typeof SourcingSearchFilterOnIndustryExpertiseAggregationEnum[keyof typeof SourcingSearchFilterOnIndustryExpertiseAggregationEnum];


/**
 * Check if a given object implements the SourcingSearchFilterOnIndustryExpertise interface.
 */
export function instanceOfSourcingSearchFilterOnIndustryExpertise(value: object): value is SourcingSearchFilterOnIndustryExpertise {
    if (!('humanIds' in value) || value['humanIds'] === undefined) return false;
    return true;
}

export function SourcingSearchFilterOnIndustryExpertiseFromJSON(json: any): SourcingSearchFilterOnIndustryExpertise {
    return SourcingSearchFilterOnIndustryExpertiseFromJSONTyped(json, false);
}

export function SourcingSearchFilterOnIndustryExpertiseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SourcingSearchFilterOnIndustryExpertise {
    if (json == null) {
        return json;
    }
    return {
        
        'humanIds': json['humanIds'],
        'ratingTwoOrMoreRequired': json['ratingTwoOrMoreRequired'] == null ? undefined : json['ratingTwoOrMoreRequired'],
        'aggregation': json['aggregation'] == null ? undefined : json['aggregation'],
    };
}

export function SourcingSearchFilterOnIndustryExpertiseToJSON(value?: SourcingSearchFilterOnIndustryExpertise | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'humanIds': value['humanIds'],
        'ratingTwoOrMoreRequired': value['ratingTwoOrMoreRequired'],
        'aggregation': value['aggregation'],
    };
}

